import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MzLink from "@markaaz/ui/MzLink";

const sx = {
  root: {
    textAlign: "center",
    maxWidth: "858px"
  }
};

const SignUpFooter = (props) => {
  const theme = useTheme();
  return (
    <Box sx={sx.root}>
      <Typography variant="caption" color={theme.palette.darkBlue.c70}>
        By creating an account, I acknowledge I have read, understand, and agree to the Markaaz's&nbsp;
        <MzLink href="https://markaaz.com/terms-and-conditions/" target="_blank" rel="noreferrer">
          Terms and Conditions
        </MzLink>
        , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have read
        and understand the Markaaz&nbsp;
        <MzLink href="https://markaaz.com/privacy/" target="_blank" rel="noreferrer">
          Privacy Policy
        </MzLink>
      </Typography>
    </Box>
  );
};

export default SignUpFooter;
